import { CSS, StyleProps } from "@shared/primitive-components"

export const error = (props: StyleProps) => ({
  color: props.theme.palette.error,
})

export const advisory = (props: StyleProps): CSS => ({
  margin: `${props.theme.pxToEm(20)} 0`,
})
